import { Language } from './types'

// Common ISO 639-1 codes accepted by Sprinklr's closedCaptions languageCode
// field. The Rails AssetReference stores `language_code` as a free-form
// string, so the dropdown's job is just to surface a sensible curated list.
// Add to this if a customer needs a specific code we haven't listed.
export const SUPPORTED_LANGUAGES: ReadonlyArray<Language> = [
  { id: 1, system_name: 'en', name: 'English' },
  { id: 2, system_name: 'es', name: 'Spanish' },
  { id: 3, system_name: 'fr', name: 'French' },
  { id: 4, system_name: 'de', name: 'German' },
  { id: 5, system_name: 'it', name: 'Italian' },
  { id: 6, system_name: 'pt', name: 'Portuguese' },
  { id: 7, system_name: 'nl', name: 'Dutch' },
  { id: 8, system_name: 'sv', name: 'Swedish' },
  { id: 9, system_name: 'da', name: 'Danish' },
  { id: 10, system_name: 'no', name: 'Norwegian' },
  { id: 11, system_name: 'fi', name: 'Finnish' },
  { id: 12, system_name: 'pl', name: 'Polish' },
  { id: 13, system_name: 'ru', name: 'Russian' },
  { id: 14, system_name: 'tr', name: 'Turkish' },
  { id: 15, system_name: 'ar', name: 'Arabic' },
  { id: 16, system_name: 'he', name: 'Hebrew' },
  { id: 17, system_name: 'hi', name: 'Hindi' },
  { id: 18, system_name: 'ja', name: 'Japanese' },
  { id: 19, system_name: 'ko', name: 'Korean' },
  { id: 20, system_name: 'zh', name: 'Chinese' },
  { id: 21, system_name: 'th', name: 'Thai' },
  { id: 22, system_name: 'vi', name: 'Vietnamese' },
  { id: 23, system_name: 'id', name: 'Indonesian' },
  { id: 24, system_name: 'ms', name: 'Malay' },
]
